import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  EXPORT_TYPES,
  MODULES,
  PERMISSION_TYPE,
  PERMISSIONS_KEY,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import ClosureRequestsTable from '../components/ClosureRequestsTable';
import LibraryTabs from '../components/LibraryTabs';
import { REQUEST_LIBRARY_REQUESTS_EXPORT } from '../graphql/Mutations';

const ClosureRequests = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isRaiseRequestModalOpen, setIsRaiseRequestModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestLibraryRequestsExport] = useMutation(
    REQUEST_LIBRARY_REQUESTS_EXPORT,
    {
      onError: () => {},
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestLibraryRequestsExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.LIBRARY_CLOSURE,
        },
        filter: {
          search: exportFilter?.search,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          actionTakenOn: {
            from: exportFilter?.actionTakenOn?.from?.$d,
            to: exportFilter?.actionTakenOn?.to?.$d,
          },
          libraryIds: exportFilter?.name,
          backUpLibraryIds: exportFilter?.backUpLibName,
          closureRequestToDateRange: {
            to: exportFilter?.toDate?.date?.$d,
          },
          closureRequestFromDateRange: {
            from: exportFilter?.fromDate?.date?.$d,
          },
          status:
            exportFilter?.status?.length > 0 ? exportFilter?.status : undefined,
          isArchived: exportFilter?.isArchived,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.LIBRARY}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.REQUESTS_LIBRARY_CLOSURE_REQUESTS,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            onClick={() => setIsRaiseRequestModalOpen(true)}
          >
            Raise Request
          </Button>
        )}
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.REQUESTS_LIBRARY_CLOSURE_REQUESTS,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            onClick={() => setIsRaiseRequestModalOpen(true)}
          >
            Raise Request
          </Button>
        )}
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <LibraryTabs>
        <div className="tab-table">
          <ClosureRequestsTable
            exportFilter={exportFilter}
            setExportFilter={setExportFilter}
            isRaiseRequestModalOpen={isRaiseRequestModalOpen}
            setIsRaiseRequestModalOpen={setIsRaiseRequestModalOpen}
          />
        </div>
      </LibraryTabs>
    </>
  );
};

export default ClosureRequests;
